import { render, staticRenderFns } from "./Huduan.vue?vue&type=template&id=05ba8b50"
import script from "./Huduan.vue?vue&type=script&lang=js"
export * from "./Huduan.vue?vue&type=script&lang=js"
import style0 from "./Huduan.vue?vue&type=style&index=0&id=05ba8b50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports